{
  "name": "@ns/public-ledger-fund-test-company",
  "version": "1.0.0",
  "description": "Outside production a MAINNET company can't buy nodeStream credits, so the PUBLIC_LEDGER team funds its public ledger account by hand, outside nodeStream, and enters the amount. Only public-ledger-credits-confirm-test-funding completes it funded, after reading the company account's balance fresh.",
  "inputs": {},
  "outcomes": {
    "funded": {
      "serverOnly": true,
      "inputs": {
        "fundedCredits": {
          "type": "number"
        }
      }
    }
  }
}
